import React, { Fragment } from 'react'
import { CardCampaign, Heading, HeadingLines, MoreLink } from '@website2018/da-dobsonville'

const Governments = props => {
  if (!props.list.length) return null

  return (
    <Fragment>
      <HeadingLines lineLeft color={'red'} mb={'large'}>
        <Heading color={'red'} tracking={'huge'} size={'tiny'} weight={'regular'} uppercase>
          {props.title}
        </Heading>
      </HeadingLines>
      <div className="row">
        {props.list.map(c => {
          const inner = (
            <CardCampaign
              key={c.id}
              title={c.title.rendered}
              paragraph={c.excerpt.rendered}
              imageUrl={c.featured_media ? c.featured_media.source_url : null}
              renderCta={hover => (
                <MoreLink hover={hover} color={'red'}>
                  View More
                </MoreLink>
              )}
            />
          )

          return (
            <div className={props.grid}>
              <a target="blank" href={`https://www.da.org.za/government/${c.slug}`} key={c.id}>
                {inner}
              </a>
            </div>
          )
        })}
      </div>
    </Fragment>
  )
}

Governments.defaultProps = {
  grid: 'col-md-12',
  view: false,
  list: []
}

export default Governments
